export const sip_account = {
  modal: {
    remove: {
      content: `Вы действительно хотите удалить SIP-аккаунт <b> {name} <b>?`
    }
  },

  table: {
    field: {
      login: 'Логин',
      host: 'Хост',
      password: 'Пароль',
      internal_number_id: 'Внутренний номер',
      caller_id: 'Внешний номер'
    }
  },

  form: {
    title: {
      edit: {
        main: 'Данные SIP-Аккаунта',
        in_phone: 'Внутренний номер АТС',
        out_phone: 'Исходящий номер АТС'
      }
    },

    field: {
      name: 'Имя',
      login: 'Логин',
      password: 'Пароль',
      host: 'Хост',
      in_phone: 'Внутренний номер',
      out_phone: 'Исходящий номер',
      wrtc: 'Поддержка webRTC'
    },

    tooltips: {
      login: 'Логин генерируется автоматически',
      password: 'Пароль генерируется автоматически'
    }
  }
};
